module.exports = __webpack_public_path__ + "img/frame (187).fec27f7b.jpg";